import { RouteObject } from 'react-router-dom';
import CategorySelectionView from './views/CategorySelectionView';
import CustomerOnboardingView from './views/CustomerOnboardingView';
import IndividualOnboardingView from './views/IndividualOnboardingView';
import GroupOnboardingView from './views/GroupOnboardingView';
import BusinessOnboardingView from './views/BusinessOnboardingView';

const routes: RouteObject[] = [
  {
    path: '/customers/onboarding',
    element: <CustomerOnboardingView />,
    children: [
      {
        index: true,
        element: <CategorySelectionView />,
      },
      {
        path: 'individual/:categoryId',
        element: <IndividualOnboardingView />,
      },
      {
        path: 'group/:categoryId',
        element: <GroupOnboardingView />,
      },
      {
        path: 'business/:categoryId',
        element: <BusinessOnboardingView />,
      },
    ],
  },
];

export default routes;
